import React from 'react';
import { WidgetLayout } from '../shared/WidgetLayout/WidgetLayout';
import s from './SingleSelectButtonWidget.module.scss';
import { WidgetButton } from '../shared/WidgetButton/WidgetButton';
import { useDisabledWidget } from '../../../shared/disabled-widget/useDisabledWidget';
import { WithDisabledControl } from '../../../shared/disabled-widget/WithDisabledControl';
export const SingleSelectButtonWidget = _ref => {
  var _data$secondaryButton;
  let {
    data,
    context,
    config
  } = _ref;
  const {
    areControlsDisabled,
    enableControls
  } = useDisabledWidget(config);
  const handleButtonClick = function (action, label) {
    if (label === void 0) {
      label = '';
    }
    const handler = effects => {
      const onWidgetActionData = {
        action,
        value: {
          label,
          effects
        }
      };
      context.onWidgetAction(SINGLE_SELECT_BUTTON_WIDGET, onWidgetActionData, data.text);
    };
    return handler;
  };
  const optionElements = (data.options || []).map(option => /*#__PURE__*/React.createElement(WithDisabledControl, {
    isDisabled: areControlsDisabled,
    onEnable: enableControls,
    t: context.t
  }, /*#__PURE__*/React.createElement(WidgetButton, {
    className: s.optionButton,
    key: option.value,
    type: "textButton",
    selectedValues: [option.value],
    selectedTitles: [option.button.label],
    respondText: option.button.respondText,
    webAction: option.button.webAction,
    context: context,
    icon: option.button.icon,
    sideEffect: option.button.sideEffect,
    onClick: handleButtonClick('option_button_click', option.button.label),
    disabled: areControlsDisabled
  }, option.button.label)));
  return /*#__PURE__*/React.createElement(WidgetLayout, {
    context: context,
    text: data.text,
    secondaryButton: data.secondaryButton,
    onSecondaryButtonClick: handleButtonClick('secondary_button_click', (_data$secondaryButton = data.secondaryButton) == null ? void 0 : _data$secondaryButton.label),
    disabled: areControlsDisabled,
    onEnableControls: enableControls
  }, optionElements);
};
export const SINGLE_SELECT_BUTTON_WIDGET = 'SINGLE_SELECT_BUTTON_WIDGET';
//# sourceMappingURL=SingleSelectButtonWidget.js.map